// extracted by mini-css-extract-plugin
export default {"span":"JmQzCc8Ufrs8JS8QjJtB"};